import { RootState } from "@/modules/common";

export const selectBalanceDiscount = (state: RootState) =>
  state.basket.basket.balanceDiscount;
